export default "__VITE_ASSET__Cou5h$HN__"